export const FILE_NAME_REGEX = /(\d+_[0-9a-z\-]+?_\d+\.json)\\?["']/gi;
export const DOMAIN_REGEX = /^https?:\/\/([^:\/\n]+)/im;
export const AT_URL_REGEX = /^https?:\/\/[a-zA-Z0-9\-]+\.koc\.asia\/?$/;
export const SHOPEE_AFF_URL_REGEX = /^https:\/\/mycollection\.shop\/[a-zA-Z0-9\-._]+\/?$/;
export const AT_CATEGORY_REGEX = /vi_json\s+\=\s+{(?:.|\n)*?}/gi;
export const MSHAKE_URL_REGEX = /^https:\/\/msha\.ke\/[a-zA-Z0-9_\-]+(?:#[a-zA-Z0-9_\-]+)?$/;
export const LINKTREE_URL_REGEX = /^https:\/\/linktr\.ee\/[a-zA-Z0-9_\-]+(?:\?[a-zA-Z0-9_=&%-]+)?$/;